export const PRIVACY_POLICY = "PRIVACY_POLICY";
export const PRIVACY_POLICY_SUCCESS = "PRIVACY_POLICY_SUCCESS";
export const PRIVACY_POLICY_FAIL = "PRIVACY_POLICY_FAIL";